import React, { createContext, useContext, useState } from 'react';

const CountryContext = createContext();

export const useCountry = () => {
  const context = useContext(CountryContext);
  if (!context) {
    throw new Error('useCountry must be used within a CountryProvider');
  }
  return context;
};

   const countryData = {
//   ALL: { label: "All Countries", flag: "https://cdn-icons-png.flaticon.com/512/44/44386.png" },
  SG: { label: "Singapore", flag: "https://flagcdn.com/w40/sg.png" },
  MY: { label: "Malaysia", flag: "https://flagcdn.com/w40/my.png" },
  ID: { label: "Indonesia", flag: "https://flagcdn.com/w40/id.png" },
  PH: { label: "Philippines", flag: "https://flagcdn.com/w40/ph.png" },
  VN: { label: "Vietnam", flag: "https://flagcdn.com/w40/vn.png" },
  TH: { label: "Thailand", flag: "https://flagcdn.com/w40/th.png" },
};



export const CountryProvider = ({ children }) => {
  const [selectedCountry, setSelectedCountry] = useState('MY');
  const [countries, setCountries] = useState([]);
const [availableBrands, setAvailableBrands] = useState([]);
const [projectno, setProjectno] = useState('1');
const [countryName, setCountryName] = useState('Malaysia');
  const [availableCities, setAvailableCities] = useState([]);
  const [availableWaves, setAvailableWaves] = useState([]);
  const [availableCats, setAvailableCat] = useState([]);
  const [globalFilter, setGlobalFilter] = useState('Brand Funnel');
const [filters, setFilters] = useState({
    brands: [],
    countries: [],
    wave: '',
    cat:'Total Transport',
city:'Total'    
  });  
  
  const handleFilterChange = (newFilters) => {
    setFilters({...filters, ...newFilters});
  };

  
  const updateCountry = (country) => {
    setSelectedCountry(country);
      setCountryName(countryData[country].label);
  };

const setCountryname = (code) => {
    setCountryName(countryData[code].label);
  };

  const setAvailableCountries = (countryList) => {
    setCountries(countryList);
  };

  const value = {
    selectedCountry,
    countries,
    updateCountry,
    setAvailableCountries,
    setCountryname,
    countryName,availableWaves, setAvailableWaves,availableBrands, setAvailableBrands,availableCities, setAvailableCities,filters, setFilters,handleFilterChange,globalFilter, setGlobalFilter,projectno, setProjectno,availableCats, setAvailableCat
  };

  return (
    <CountryContext.Provider value={value}>
      {children}
    </CountryContext.Provider>
  );
};

export default CountryContext;